export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api/v1';

export const AUTO_REFRESH_INTERVAL = parseInt(import.meta.env.VITE_AUTO_REFRESH_INTERVAL || '60000');

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  SEARCH: '/search',
  LOW_STOCK: '/low-stock',
  USERS: '/users',
  TRANSFER: '/transfer',
  TRANSACTIONS: '/transactions',
  CARS: '/cars',
  SERVICES: '/services',
  REGIONS: '/regions',
  REGION_SEARCH: '/region-search',
  SERVICE_MANAGEMENT: '/service-management',
  ROUTE_MANAGEMENT: '/route-management',
  WINCH_PRICING: '/winch-pricing',
  WINCH_START_POINTS: '/winch-start-points',
  NOT_FOUND: '*',
} as const;

export const ROLE_ROUTES = {
  call_center: [ROUTES.SEARCH, ROUTES.CARS],
  accountant: [ROUTES.SEARCH, ROUTES.DASHBOARD, ROUTES.LOW_STOCK, ROUTES.TRANSACTIONS, ROUTES.CARS],
  manager: [ROUTES.SEARCH, ROUTES.DASHBOARD, ROUTES.LOW_STOCK, ROUTES.USERS, ROUTES.TRANSFER, ROUTES.TRANSACTIONS, ROUTES.CARS],
} as const;

export const STOCK_THRESHOLDS = {
  CRITICAL: 5,
  LOW: 10,
  MEDIUM: 20,
} as const;

export const STOCK_STATUS = {
  CRITICAL: 'critical',
  LOW: 'low',
  MEDIUM: 'medium',
  GOOD: 'good',
} as const;

export const ROLE_LABELS = {
  call_center: 'مركز الاتصال',
  accountant: 'محاسب',
  manager: 'مدير',
  driver: 'سائق',
} as const;

export const LOW_STOCK_FILTERS = {
  ALL: 'all',
  CRITICAL: 'critical',
  LOW: 'low',
} as const;

export const MESSAGES = {
  LOGIN_SUCCESS: 'تم تسجيل الدخول بنجاح',
  LOGIN_ERROR: 'فشل تسجيل الدخول',
  LOGOUT_SUCCESS: 'تم تسجيل الخروج بنجاح',
  COPY_SUCCESS: 'تم النسخ بنجاح',
  COPY_ERROR: 'فشل النسخ',
  NETWORK_ERROR: 'خطأ في الاتصال بالشبكة',
  UNAUTHORIZED: 'غير مصرح لك بالوصول',
  SERVER_ERROR: 'خطأ في الخادم',
} as const;
